export default "__VITE_ASSET__CIbS9_vu__"